import { Shadows } from "./Shadows";
import { Indicators } from "./Indicators";
export const ChildComponents = {
    ...Shadows,
    ...Indicators
}